import { gql } from '@apollo/client';
import { apolloClient } from '../apollo/client';
import { dispatchGlobalError } from '../context/ApiErrorContext';

const ALUNOS_DA_LIGA = gql`
  query AlunosDaLiga($ligaId: ID!) {
    alunosDaLiga(ligaId: $ligaId) {
      id
      atleta {
        id
      }
    }
  }
`;

const MARCAR_ALUNO = gql`
  mutation MarcarAluno($ligaId: ID!, $atletaId: ID!) {
    marcarAluno(ligaId: $ligaId, atletaId: $atletaId) {
      id
      atleta { id }
    }
  }
`;

const DESMARCAR_ALUNO = gql`
  mutation DesmarcarAluno($ligaId: ID!, $atletaId: ID!) {
    desmarcarAluno(ligaId: $ligaId, atletaId: $atletaId)
  }
`;

const MARCAR_EM_MASSA = gql`
  mutation MarcarAlunosEmMassa($ligaId: ID!, $atletaIds: [ID!]!) {
    marcarAlunosEmMassa(ligaId: $ligaId, atletaIds: $atletaIds)
  }
`;

const DESMARCAR_EM_MASSA = gql`
  mutation DesmarcarAlunosEmMassa($ligaId: ID!, $atletaIds: [ID!]!) {
    desmarcarAlunosEmMassa(ligaId: $ligaId, atletaIds: $atletaIds)
  }
`;

function extractMessage(error: unknown): string {
  if (error instanceof Error) return error.message;
  return 'Erro inesperado';
}

export const buscarAlunosDaLiga = async (ligaId: string): Promise<string[]> => {
  try {
    const { data } = await apolloClient.query({
      query: ALUNOS_DA_LIGA,
      variables: { ligaId },
      fetchPolicy: 'network-only',
    });
    return (data?.alunosDaLiga ?? []).map((a: any) => a.atleta.id as string);
  } catch (error) {
    dispatchGlobalError(extractMessage(error));
    return [];
  }
};

export const marcarAluno = async (ligaId: string, atletaId: string): Promise<boolean> => {
  try {
    await apolloClient.mutate({ mutation: MARCAR_ALUNO, variables: { ligaId, atletaId } });
    return true;
  } catch (error) {
    dispatchGlobalError(extractMessage(error));
    return false;
  }
};

export const desmarcarAluno = async (ligaId: string, atletaId: string): Promise<boolean> => {
  try {
    await apolloClient.mutate({ mutation: DESMARCAR_ALUNO, variables: { ligaId, atletaId } });
    return true;
  } catch (error) {
    dispatchGlobalError(extractMessage(error));
    return false;
  }
};

export const marcarAlunosEmMassa = async (ligaId: string, atletaIds: string[]): Promise<boolean> => {
  try {
    await apolloClient.mutate({ mutation: MARCAR_EM_MASSA, variables: { ligaId, atletaIds } });
    return true;
  } catch (error) {
    dispatchGlobalError(extractMessage(error));
    return false;
  }
};

export const desmarcarAlunosEmMassa = async (ligaId: string, atletaIds: string[]): Promise<boolean> => {
  try {
    await apolloClient.mutate({ mutation: DESMARCAR_EM_MASSA, variables: { ligaId, atletaIds } });
    return true;
  } catch (error) {
    dispatchGlobalError(extractMessage(error));
    return false;
  }
};
